import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  TemplateRef,
} from '@angular/core';
import type { IconDefinition } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'bo-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class WidgetComponent {
  @HostBinding('class') class = 'bo-widget';

  @Input()
  public icon?: IconDefinition;

  @Input()
  public headerTemplate?: TemplateRef<unknown>;
}
